// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

:root {
  /* Colors */
  --prim-color-blue-500: #1976d2;
  --prim-color-blue-600: #1565c0;
  --prim-color-blue-700: #0d47a1;
  --prim-color-green-500: #2e7d32;
  --prim-color-amber-500: #f57c00;
  --prim-color-red-500: #c62828;
  --prim-color-grey-50: #fafafa;
  --prim-color-grey-100: #f5f5f5;
  --prim-color-grey-200: #eeeeee;
  --prim-color-grey-300: #e0e0e0;
  --prim-color-grey-700: #616161;
  --prim-color-grey-900: #212121;
  --prim-color-white: #ffffff;
  --prim-color-black: #000000;

  /* AI Gradient */
  --prim-gradient-ai: linear-gradient(135deg, #7c3aed 0%, #2563eb 50%, #06b6d4 100%);

  /* Spacing */
  --prim-space-1: 4px;
  --prim-space-2: 8px;
  --prim-space-3: 12px;
  --prim-space-4: 16px;
  --prim-space-6: 24px;
  --prim-space-8: 32px;

  /* Border radius */
  --prim-radius-sm: 4px;
  --prim-radius-md: 8px;
  --prim-radius-lg: 16px;
  --prim-radius-full: 9999px;

  /* Shadows */
  --prim-shadow-sm: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.08);
  --prim-shadow-md: 0 4px 6px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.06);

  /* Font sizes */
  --prim-font-size-sm: 12px;
  --prim-font-size-md: 14px;
  --prim-font-size-lg: 16px;
  --prim-font-size-xl: 20px;
  --prim-font-size-2xl: 24px;
}
`, "",{"version":3,"sources":["webpack://./tokens/primitives.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;;EAE3B,gBAAgB;EAChB,kFAAkF;;EAElF,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;;EAE1B,YAAY;EACZ,wEAAwE;EACxE,wEAAwE;;EAExE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;AAC5B","sourcesContent":["html {\n  text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\n\n:root {\n  /* Colors */\n  --prim-color-blue-500: #1976d2;\n  --prim-color-blue-600: #1565c0;\n  --prim-color-blue-700: #0d47a1;\n  --prim-color-green-500: #2e7d32;\n  --prim-color-amber-500: #f57c00;\n  --prim-color-red-500: #c62828;\n  --prim-color-grey-50: #fafafa;\n  --prim-color-grey-100: #f5f5f5;\n  --prim-color-grey-200: #eeeeee;\n  --prim-color-grey-300: #e0e0e0;\n  --prim-color-grey-700: #616161;\n  --prim-color-grey-900: #212121;\n  --prim-color-white: #ffffff;\n  --prim-color-black: #000000;\n\n  /* AI Gradient */\n  --prim-gradient-ai: linear-gradient(135deg, #7c3aed 0%, #2563eb 50%, #06b6d4 100%);\n\n  /* Spacing */\n  --prim-space-1: 4px;\n  --prim-space-2: 8px;\n  --prim-space-3: 12px;\n  --prim-space-4: 16px;\n  --prim-space-6: 24px;\n  --prim-space-8: 32px;\n\n  /* Border radius */\n  --prim-radius-sm: 4px;\n  --prim-radius-md: 8px;\n  --prim-radius-lg: 16px;\n  --prim-radius-full: 9999px;\n\n  /* Shadows */\n  --prim-shadow-sm: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.08);\n  --prim-shadow-md: 0 4px 6px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.06);\n\n  /* Font sizes */\n  --prim-font-size-sm: 12px;\n  --prim-font-size-md: 14px;\n  --prim-font-size-lg: 16px;\n  --prim-font-size-xl: 20px;\n  --prim-font-size-2xl: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
